import {
    ChatBubbleLeftRightIcon,
    CheckCircleIcon,
    ExclamationTriangleIcon,
    MegaphoneIcon,
    PhoneXMarkIcon,
    UserMinusIcon,
    UserPlusIcon,
    VideoCameraIcon,
    XCircleIcon,
    XMarkIcon,
} from '@heroicons/react/24/outline';

/** Mismos chips de color que el centro de notificaciones del nav. */
export const TOAST_TONES = {
    live: {
        Icon: VideoCameraIcon,
        chip: 'bg-emerald-50 text-emerald-600 ring-emerald-100',
    },
    ended: {
        Icon: PhoneXMarkIcon,
        chip: 'bg-slate-100 text-slate-600 ring-slate-200',
    },
    notice: {
        Icon: MegaphoneIcon,
        chip: 'bg-violet-50 text-violet-600 ring-violet-100',
    },
    chat: {
        Icon: ChatBubbleLeftRightIcon,
        chip: 'bg-sky-50 text-sky-600 ring-sky-100',
    },
    joined: {
        Icon: UserPlusIcon,
        chip: 'bg-sky-50 text-sky-600 ring-sky-100',
    },
    left: {
        Icon: UserMinusIcon,
        chip: 'bg-slate-100 text-slate-600 ring-slate-200',
    },
    success: {
        Icon: CheckCircleIcon,
        chip: 'bg-emerald-50 text-emerald-600 ring-emerald-100',
    },
    warning: {
        Icon: ExclamationTriangleIcon,
        chip: 'bg-amber-50 text-amber-600 ring-amber-100',
    },
    error: {
        Icon: XCircleIcon,
        chip: 'bg-rose-50 text-rose-600 ring-rose-100',
    },
};

/**
 * Toast visual alineado con ButtonNotifications (chip + tipografía).
 */
export const AppToast = ({
    visible,
    title,
    message,
    tone = 'chat',
    onDismiss,
}) => {
    const { Icon, chip } = TOAST_TONES[tone] || TOAST_TONES.chat;

    return (
        <div
            role="status"
            aria-live="polite"
            className={[
                'pointer-events-auto flex w-[min(100vw-2rem,22rem)] items-start gap-3 rounded-xl',
                'border border-slate-200/80 bg-white p-3.5 shadow-lg shadow-slate-900/10',
                'transition-all duration-200 ease-out',
                visible
                    ? 'translate-y-0 opacity-100'
                    : 'translate-y-1 opacity-0',
            ].join(' ')}
        >
            <span
                aria-hidden="true"
                className={`mt-0.5 flex h-9 w-9 flex-shrink-0 items-center justify-center rounded-xl ring-1 ${chip}`}
            >
                <Icon className="h-[18px] w-[18px]" />
            </span>

            <div className="min-w-0 flex-1 pt-0.5">
                {title ? (
                    <p
                        className={[
                            'm-0 text-sm font-semibold leading-5 text-slate-900',
                            tone === 'joined' || tone === 'left' ? 'capitalize' : '',
                        ].join(' ')}
                    >
                        {title}
                    </p>
                ) : null}
                {message ? (
                    <p
                        className={[
                            'm-0 text-xs leading-5 text-slate-500',
                            title ? 'mt-0.5' : 'text-sm font-medium text-slate-800',
                        ].join(' ')}
                    >
                        {message}
                    </p>
                ) : null}
            </div>

            {typeof onDismiss === 'function' ? (
                <button
                    type="button"
                    onClick={onDismiss}
                    className="flex h-7 w-7 flex-shrink-0 items-center justify-center rounded-lg text-slate-400 transition-colors hover:bg-slate-100 hover:text-slate-600 focus:outline-none focus-visible:ring-2 focus-visible:ring-indigo-500"
                    aria-label="Cerrar notificación"
                >
                    <XMarkIcon className="h-4 w-4" />
                </button>
            ) : null}
        </div>
    );
};
